module.exports = __webpack_public_path__ + "static/media/person1.b296787d.png";